import { useAppSelector } from "features/store";
import { ReactNode } from "react";
import { Navigate } from "react-router-dom";

type CalibrateAdminRouteProps = {
  children: ReactNode;
};

const CalibrateAdminRoute = ({ children }: CalibrateAdminRouteProps): JSX.Element => {
  const { isAuthenticated, user } = useAppSelector((state) => state.auth);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  const pp = user?.platform_profile;

  if (user && !user.is_pass_reset && !(pp && !pp.is_pass_reset)) {
    return <Navigate to="/reset-password" replace />;
  }

  const isPlatformAdmin = pp && (pp.is_superuser || pp.is_calibrate_manager) && !pp.is_archived;

  if (!user || !isPlatformAdmin) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default CalibrateAdminRoute;
